module.exports = __webpack_public_path__ + "static/media/fileText.744a644b.svg";